// src/pages/academy/academyConstants.js

export const ACADEMY_ROOT = "/dashboard/academy";

// نفس القيم الموجودة في AcademySkill.skill_type (الباك إند بيقبل MIXED كمان)
export const SKILL_TYPE_LABELS = {
  VOCABULARY: { label: "Vocabulary", color: "bg-blue-100 text-blue-700" },
  GRAMMAR: { label: "Grammar", color: "bg-purple-100 text-purple-700" },
  READING: { label: "Reading", color: "bg-amber-100 text-amber-700" },
  LISTENING: { label: "Listening", color: "bg-cyan-100 text-cyan-700" },
  SPEAKING: { label: "Speaking", color: "bg-orange-100 text-orange-700" },
  WRITING: { label: "Writing", color: "bg-pink-100 text-pink-700" },
  MIXED: { label: "Mixed", color: "bg-slate-100 text-slate-700" },
};

export const SKILL_TYPE_OPTIONS = Object.entries(SKILL_TYPE_LABELS).map(
  ([value, { label }]) => ({ value, label })
);

// ⚠️ راجع القيم دي مع choices الحقل question_order_type في AcademySkill (models.py بتاع academy).
// لو اخترت قيمة غلط الباك إند هيرجّع 400. لو سبت الاختيار "Default" مش بيتبعت وبيستخدم default الموديل.
export const QUESTION_ORDER_OPTIONS = [
  { value: "", label: "Default" },
  { value: "ORDERED", label: "Ordered" },
  { value: "RANDOM", label: "Random" },
];

// ============================================
// Content management (academy/content_views.py + content.py)
// ============================================

// كل أنواع المحتوى اللي ممكن تظهر جوه مهارة (لو MIXED بتظهر كلها).
export const CONTENT_TYPES = [
  "VOCABULARY",
  "GRAMMAR",
  "READING",
  "LISTENING",
  "SPEAKING",
  "WRITING",
];

// الأنواع "المسطّحة" اللي بتتبعت مباشرة مع academy_skill (مفيهاش أب/أبناء).
export const FLAT_CONTENT_TYPES = ["VOCABULARY", "GRAMMAR", "WRITING"];

// الأنواع اللي عندها "أب" (قطعة قراءة / تسجيل صوتي / فيديو) وأسئلة تابعة له.
export const PARENT_CONTENT_TYPES = ["READING", "LISTENING", "SPEAKING"];

// type (من الباك إند) → kind (يُستخدم في /content/<kind>/...)
// للأنواع المسطّحة ولأنواع "الأب" (القطعة/التسجيل/الفيديو نفسه).
export const CONTENT_KIND = {
  VOCABULARY: "vocabulary",
  GRAMMAR: "grammar",
  WRITING: "writing",
  READING: "reading-passage",
  LISTENING: "listening-audio",
  SPEAKING: "speaking-video",
};

// type → kind الخاص بالأسئلة التابعة (child) لأنواع "الأب".
export const CHILD_CONTENT_KIND = {
  READING: "reading-question",
  LISTENING: "listening-question",
  SPEAKING: "speaking-question",
};

// kind الأسئلة اللي شكلها MCQ (options + correct_answer) — بيشمل المسطّح والـ child بس مش الـ parent ولا writing.
export const MCQ_KINDS = [
  "vocabulary",
  "grammar",
  "reading-question",
  "listening-question",
  "speaking-question",
];

export const DIFFICULTY_OPTIONS = [
  { value: "EASY", label: "Easy" },
  { value: "MEDIUM", label: "Medium" },
  { value: "HARD", label: "Hard" },
];